import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "../deduction/deductionFragment";

const GET_ACCOUNTING_REMITTANCES = gql`
  ${DEDUCTION_FRAGMENT}
  query GetAccountingRemittances($params: GetAccountingRemittanceParams!) {
    getAccountingRemittances(params: $params) {
      total
      page
      limit
      columns {
        key
        title
      }
      innerColumns {
        key
        title
      }
      items {
        remittanceId
        checkNumber
        checkDate
        checkAmount
        cmTotal
        deductionsCount
        purchaser {
          purchaserId
          purchaserName
          purchaserKey
          qboCustomerId
          qboCustomerName
        }
        accountingDeductions {
          deductionSubTypes {
            deductionSubTypeId
            deductionSubTypeKey
            deductionSubTypeName
          }
          qboItem {
            qboItemId
            qboItemName
          }
          description
          systemGenerated
          itemsCount
          amount
          deductions {
            ...DeductionFields
          }
        }
      }
    }
  }
`;

export default GET_ACCOUNTING_REMITTANCES;
